import CalendarMonth from "./CalendarMonth";
import {AxiosInstance, AxiosRequestConfig} from "axios";
import Logger from "../../../../../dce-logger/lib/logger/Logger";
import DceAjaxAction from "../../../../../dce-ajax/lib/ajax/DceAjaxAction";

export default class CalendarI18n {

    private static instance: CalendarI18n;

    protected _months: string[] = [
        "Styczeń",
        "Luty",
        "Marzec",
        "Kwiecień",
        "Maj",
        "Czerwiec",
        "Lipiec",
        "Sierpień",
        "Wrzesień",
        "Październik",
        "Listopad",
        "Grudzień"
    ];

    protected _weekdays: string[] = [
        "Niedziela",
        "Poniedziałek",
        "Wtorek",
        "Środa",
        "Czwartek",
        "Piątek",
        "Sobota",
    ];

    protected _weekdaysShort: string[] = [
        "Nie",
        "Pn",
        "Wt",
        "Śr",
        "Czw",
        "Pt",
        "So",
    ];

    static getInstance(): CalendarI18n {
        if (!CalendarI18n.instance) {
            CalendarI18n.instance = new CalendarI18n();
        }
        return CalendarI18n.instance;
    }

    private constructor() {
    }

    public monthWithYear(m: CalendarMonth): string {
        return this._months[m.month] + " " + m.year;
    }

    public month(m: CalendarMonth): string {
        return this._months[m.month];
    }

    public weekdaysShort(): string[] {
        return this._weekdaysShort;
    }



}